export const STATUS_NEW = "new";
export const STATUS_REJECTED = "rejected";
export const STATUS_HIRED = "hired";
export const STATUS_ONBOARDED = "onboarded";
